import script from "./PaymentMethod.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentMethod.vue?vue&type=style&index=0&id=37c95060&lang=sass"

const __exports__ = script;

export default __exports__